//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SimpleCoreValues',
  props: {
    section: {
      type: Object
    }
  }
}
